import { EClickPosition } from 'shared/constant';
import { useSetAtom } from 'jotai';
import { $CTAModal } from '~/components/cta-modal';
import { SyntheticEvent, useCallback } from 'react';
import { sendClickEvent } from '~/utils/event';
import { NoOperation } from '@lemon8/web-app-shared/util';

interface IUseCTAByModalProps {
  variant?: 'primary' | 'v2';
  clickPosition: EClickPosition;
  clickId?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

type TCTAByModal = (e?: SyntheticEvent) => void;

export const useCTAByModal = (props: IUseCTAByModalProps): TCTAByModal => {
  const { variant = 'primary', clickPosition, clickId, onCancel = NoOperation, onConfirm } = props;

  const setCTAModal = useSetAtom($CTAModal);

  return useCallback(
    (e?: SyntheticEvent) => {
      // 1. prevent default event behaviour
      e?.preventDefault();

      // 2. click position
      sendClickEvent({
        clickPosition,
      });

      // 3. show cta model
      setCTAModal({
        variant,
        clickPosition,
        clickId,
        onConfirm,
        onCancel,
      });
    },
    [clickPosition, clickId, onConfirm, onCancel, setCTAModal],
  );
};
